// GIMMATEK Store 不提供的 BOB 模組功能（CNCY-10766）
// 店家方案仍可能開著這些功能（例如匯入的 BOB 組織），前端一律視為未開通：
// 保留頁面內以 feature key 控制的入口（會員頁籤、LINE 通知開關、預約結帳選項…）會一併隱藏。
// 盤點結果與相依說明見 docs/STORE_MODULE_SCOPE.md
// Store（dashboard）套用功能、Admin 方案表單隱藏自定義模組（CNCY-10864）共用這一份，不要各自維護

// 整個 namespace 不提供，視為 `${prefix}.*: false`；只能放兩段以上的 namespace，完整的 action key 放 removedFeatureKeys
export const removedFeaturePrefixes: readonly string[] = [
  // 會員等級
  'admin.memberLevel',
  'admin.memberLevelConfig',
  'admin.memberLevelRule',
  'admin.memberLevelBenefitDescription',
  'admin.memberLevelGiftConfig',
  'admin.memberLevelGiftRecord',
  // LINE 好友狀態列表、查詢會員資訊
  'admin.memberLineFriendStatus',
  'admin.memberQuery',
  // 會員檢視「特質雷達圖」：資料來自 BOB 的 businessDataChart 微服務，來源多為已移除模組（銷售、儲值金、堂票、電商…）
  'admin.beautyAIMemberAnalysis',
  // 推薦會員（行銷模組）
  'admin.memberReferralRecord',
  'admin.memberReferralReport',
  'admin.referralActivity',
  // 儲值金
  'admin.walletRecord',
  'admin.walletConfig',
  // 回饋金
  'admin.shopCashback',
  'admin.shopCashbackReport',
  'admin.salesCashback',
  'planModule.shopCashback',
  // 點數
  'admin.shopPoint',
  'admin.shopPointLink',
  'admin.shopPointLinkCode',
  'admin.shopPointReport',
  'planModule.shopPoint',
  'admin.externalPointConfig',
  'admin.externalPointWallet',
  // 堂票
  'admin.classTicket',
  'admin.classTicketRecord',
  'admin.classTicketConfig',
  'planModule.classTicket',
  'admin.appointmentReservationTicket',
  // 票券、票匣
  'admin.coupon',
  'admin.couponConfig',
  'admin.couponExchange',
  'admin.couponRecord',
  'admin.couponOpentix',
  'admin.couponPospal',
  'admin.couponTkhspc',
  'admin.couponCyjPos',
  'admin.couponXigogo',
  'admin.ticketBox',
  'admin.ticketBoxRecord',
  'admin.ticketBoxConfig',
  'planModule.coupon',
  'planModule.couponExchange',
  // 電商
  'admin.ecommerceOrder',
  'admin.ecommerceProduct',
  'admin.ecommerceConfig',
  'planModule.ecommerce',
  'planModule.ecommerceSidebarConfig',
  'admin.ecommerceSidebarConfig',
  'admin.ecommerceCashback',
  // 銷售紀錄、門市
  'admin.salesRecord',
  'admin.salesConfig',
  'admin.salesProduct',
  'admin.salesReport',
  'adminView.salesPos',
  'adminView.salesRecord',
  'planModule.sales',
  'admin.branch',
  // 電子發票
  'admin.invoiceRecord',
  'admin.invoiceConfig',
  // 抽獎
  'admin.lottery',
  'admin.lotteryAward',
  'admin.memberGame',
  'admin.memberGameRecord',
  // 次卡、點數卡
  'admin.punchCard',
  'admin.punchCardRecord',
  'admin.punchCardConfig',
  'planModule.punchCard',
  'admin.pointCard',
  'admin.pointCardRecord',
  'admin.pointCardConfig',
  'planModule.pointCard',
  // 進場
  'admin.entryControlRecord',
  'admin.entryControlConfig',
  // 第三方交易、第三方儲值金
  'admin.memberExternalTransaction',
  'admin.orgExternalTransaction',
  'admin.headquarterExternalTransaction',
  'admin.externalWallet',
  'admin.externalWalletConfig',
  'admin.externalWalletRecord',
  // 訂閱
  'admin.subscriptionOrder',
  'admin.subscriptionPlan',
  'admin.subscriptionConfig',
  // 課程
  'planModule.course',
  'admin.courseOrder',
  // 會員商城
  'adminView.memberStoreOrder',
  'adminView.memberStoreProduct',
  'admin.memberStoreProduct',
  // 會員權益
  'admin.periodicBenefitRecord',
  'admin.periodicBenefitTemplate',
  'admin.periodicBenefitConfig',
  'planModule.periodicBenefit',
  // 獎勵發放
  'admin.rewardDistribution',
  // 簽名紀錄、服務後評分、報到頁面、跨境預約、企業模組、車輛、門禁
  'admin.signatureRecordMapping',
  'admin.customerFeedbackRecord',
  'admin.customerFeedbackConfig',
  'admin.checkInPageSetting',
  'admin.pubAptConfig',
  'admin.pubAptPaymentConfig',
  'admin.shopCompanyDirectory',
  'admin.keeperVehicle',
  'admin.miezoAccessControlPassword',
]

// 保留模組 namespace 內、屬於已移除模組的單一功能
export const removedFeatureKeys: readonly string[] = [
  // 會員等級
  'admin.member.findLevelRecord',
  'admin.member.countLevelRecord',
  'admin.member.findCurrentLevelRecord',
  // 儲值金
  'admin.member.adminUseWallet',
  'admin.member.depositWallet',
  'admin.member.findWalletRecord',
  'admin.member.countWalletRecord',
  'admin.member.findOne.wallet',
  // 回饋金
  'adminView.member.shopCashback',
  'adminView.appointmentOrder.checkoutCashbackDeduction',
  'admin.member.findOneCashbackWallet',
  'admin.member.addCashbackWalletRecord',
  'admin.member.useCashbackWalletRecord',
  'admin.member.findOneCashbackWalletYearExpirations',
  'admin.member.findCashbackWalletRecord',
  'admin.member.countCashbackWalletRecord',
  'adminView.ecommerceProduct.useCashbackRate',
  // 會員中心（client）的功能開關
  'client.memberCenterConfig.shopCashback',
  'client.memberCenterConfig.punchCard',
  'client.memberCenterConfig.pointCard',
  'client.memberCenterConfig.periodicBenefitRecord',
  // 點數
  'admin.member.findOnePointWallet',
  'admin.member.addPointWalletRecord',
  'admin.member.usePointWalletRecord',
  // 銷售紀錄
  'adminView.member.exportWithShowSalesRecordTotalPaymentPriceSum',
  // 預約綁定堂票
  'admin.appointmentService.bindClassTicket',
  'admin.appointmentDepositConfig.enableClassTicketCredit',
]

export const isRemovedFeature = (key: string): boolean => {
  if (removedFeatureKeys.includes(key)) return true
  return removedFeaturePrefixes.some((prefix) => key === prefix || key.startsWith(`${prefix}.`))
}

/**
 * 自定義模組的功能 key 全部落在 Store 移除範圍 ＝ Store 不會出現任何對應功能（CNCY-10864）。
 * 沒有功能 key 的模組（純旗標）無從判斷，視為保留。
 */
export const isStoreRemovedModule = (customizeFeatures: Record<string, unknown> | null | undefined): boolean => {
  const keys = Object.keys(customizeFeatures ?? {})
  return keys.length > 0 && keys.every(isRemovedFeature)
}
